<div class="content">
    <ng-content select="fui-chrome-actions"></ng-content>
    <ng-content select="fui-chrome-branding"></ng-content>
</div>
<div class="title-holder">
    <ng-content select="fui-chrome-controls.title"></ng-content>
</div>
<div class="utilities">
    <ng-content select="fui-chrome-controls"></ng-content>
</div>
